import React from 'react';

const TimeTrackingIcon = ({ className = '' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_7_1752)">
        <path
          d="M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8.00004C14.6666 4.31814 11.6818 1.33337 7.99992 1.33337C4.31802 1.33337 1.33325 4.31814 1.33325 8.00004C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z"
          stroke="currentColor"
        />
        <path
          d="M8.00513 7.00547C7.45286 7.00547 7.00513 7.4532 7.00513 8.00547C7.00513 8.55774 7.45286 9.00547 8.00513 9.00547C8.55739 9.00547 9.00513 8.55774 9.00513 8.00547C9.00513 7.4532 8.55739 7.00547 8.00513 7.00547ZM8.00513 7.00547V4.66602M10.0097 10.0132L8.71066 8.71414"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7_1752">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TimeTrackingIcon;
